import { ChangeDetectionStrategy, Component, inject, Injector } from '@angular/core';
import { NgbDropdownModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseHelpService } from '../../services';
import { AnatomicalSideLabelPipe, BaseNavbarComponent, BoneTypeLabelPipe, ConfirmationComponent, HelpComponent, PlanTypeLabelPipe, ReplaceLongLegPipe } from '../../shared';
import { ViewHelpService } from '../services';


/**
 * Horizontal bar on top of view page.
 */
@Component({
	selector: 'vw-navbar',
	templateUrl: '../../shared/base-navbar/base-navbar.component.html',
	imports: [
		NgbDropdownModule,
		BoneTypeLabelPipe,
		PlanTypeLabelPipe,
		ReplaceLongLegPipe,
		AnatomicalSideLabelPipe
	],
	changeDetection: ChangeDetectionStrategy.Eager,
})
export class VwNavbarComponent extends BaseNavbarComponent {

	private readonly modalSrv = inject(NgbModal);
	private readonly injector = inject(Injector);

	/**
	* Open modal of help info.
	*/
	override openHelpModal(): void {
		if (!this.modalSrv.hasOpenModals()) {
			this.modalSrv.open(HelpComponent, {
				backdropClass: 'wrapper-modal-help', windowClass: 'wrapper-modal-help', injector:
					Injector.create({
						parent: this.injector,
						providers: [{ provide: BaseHelpService, useClass: ViewHelpService }]
					})
			});
		}
	}

	/**
	 * Open confirm modal before exit.
	 */
	override openClosingModal(): void {
		if (!this.modalSrv.hasOpenModals()) {
			const modalRef = this.modalSrv.open(ConfirmationComponent, { centered: true, backdrop: 'static' });
			(modalRef.componentInstance as ConfirmationComponent).config = {
				title: this.labels().VIEW_NAVBAR_COMPONENT_BACK_PATIENT_MODAL_TITLE,
				message: this.labels().VIEW_NAVBAR_COMPONENT_BACK_PATIENT_MODAL_MSG
			};
			modalRef.result.then(() => this.goToPatientSite()).catch(() => false);
		}
	}

	private goToPatientSite(): void {
		globalThis.location.href = this.config.patplanSite;
	}

}
